export function debounce(func: (...args: any) => any, delay: number) {
	let timer;
	return function (...args) {
		clearTimeout(timer);
		timer = setTimeout(() => {
			func(...args);
		}, delay);
	};
}

export function throttle(func: (...args: any) => any, limit: number) {
	let inThrottle: boolean;
	return function (...args) {
		if (!inThrottle) {
			func(...args);
			inThrottle = true;
			setTimeout(() => (inThrottle = false), limit);
		}
	};
}
